import React from "react";
import next_btn from "../../img/next-link.svg";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Link } from "react-router-dom";
import { getAuthToken } from "../../utils/auth";

const WelfareSection = () => {
  const isAuthenticated = !!getAuthToken();
  return (
    <>
      <section className="new-card-sectinon help_hero_card">
        <div className="help_hero_card_inner">
          <div className="card-box-container">
            <div className="card-box help_card_one">
              <div className="card_inner">
                <div className="card-box-image"></div>
                <div className="card_dsec">
                  <h3>01</h3>
                  <h2>
                    <span>Need help Ask</span> for donation
                  </h2>
                  <p>Ask for donation</p>
                </div>
                <div className="donate_now_btn">
                  <Link to={!isAuthenticated ? "/login" : "/add/post"}>
                    <button class="hlp_btn" aria-label="Donate Now">
                      <img src={next_btn} alt="Donate Now" />
                    </button>
                  </Link>
                </div>
              </div>
            </div>
            <div className="card-box">
              <div className="card_inner">
                <div className="card-box-image red_bg_style"></div>
                <div className="card_dsec">
                  <h3>02</h3>
                  <h2>
                    <span>Want to check out </span> <span> what we do all</span>{" "}
                    our transactions
                  </h2>
                  <p>Check our transactions</p>
                </div>
                <div className="donate_now_btn">
                  <Link to={"/posts"}>
                    <button class="check_out" aria-label="Donate Now">
                      <img src={next_btn} alt="Donate Now" />
                    </button>
                  </Link>
                </div>
              </div>
            </div>
            <div className="card-box">
              <div className="card_inner">
                <div className="card-box-image blue_card"></div>
                <div className="card_dsec">
                  <h3>03</h3>
                  <h2>
                    <span>Would You like</span> to donate
                  </h2>
                  <p>Donate now</p>
                </div>
                <div className="donate_now_btn">
                <Link to={"/posts"}>
                  <button class="you_like" aria-label="Donate Now">
                    <img src={next_btn} alt="Donate Now" />
                  </button>
                  </Link>
                </div>
              </div>
            </div>
            <div className="card-box">
              <div className="card_inner">
                <div className="card-box-image brown_card"></div>
                <div className="card_dsec">
                  <h3>04</h3>
                  <h2>
                    My profile<span>&nbsp;</span>
                  </h2>
                  <p>&nbsp;</p>
                </div>
                <div className="donate_now_btn">
                <Link to={!isAuthenticated ? "/login" : "/profile"}>
                  <button class="you_like" aria-label="Donate Now">
                    <img src={next_btn} alt="Donate Now" />
                  </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WelfareSection;
